import React from 'react';

/** Displays a colored dot */
const PanelIcon = ({ color = IconColors.Blue }) => {
	const style = {
		display: 'inline-block',
		minWidth: '0.5em',
		minHeight: '0.5em',
		borderRadius: '10em',
		background: color,
		border: 'none'
	};
	return <span className="css-panel-icon" style={style}></span>;
};

export const IconColors = Object.freeze({
	LightGreen: '#9bbb59',
	Green: '#728e3a',
	Orange: '#ff6600',
	Yellow: '#ffc000',
	Blue: '#1f497d'
});

export default PanelIcon;
